import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useAnchor = () => {
    const [anchor, setAnchor] = useState('');
    const { url } = useDomainConfig();
    const router = useRouter();

    useEffect(() => {
        const updateAnchor = () => {
            const { hash } = new URL(router.asPath, url);
            setAnchor(hash.slice(1));
        };

        updateAnchor();
        window.addEventListener('hashchange', updateAnchor);

        return () => window.removeEventListener('hashchange', updateAnchor);
    }, []);

    return anchor;
};
